import { fetcher } from '@commenda/utils';
import { WORKFLOW_EXECUTION_BASE_URL } from './helpers';

/**
 * Reset a workflow execution back to a target step definition. Re-opens the
 * target step and discards progress on every step after it (the backend rejects
 * the reset if a downstream step has already spawned a child workflow).
 */
export async function resetWorkflowToStep({
  workflowExecutionId,
  targetStepDefinitionId,
}: {
  workflowExecutionId: string;
  targetStepDefinitionId: string;
}) {
  const response = await fetcher(
    `${WORKFLOW_EXECUTION_BASE_URL}/${workflowExecutionId}/reset`,
    {
      method: 'POST',
      body: { targetStepDefinitionId },
    }
  );

  return response;
}
